import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore from "swiper";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { defaultImg } from "../../constants/common-constants";
import { notAvailableImg } from "../../constants/common-constants";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getEdgeClass } from "../../utils";

// Initialize Swiper with Navigation module
SwiperCore.use([Navigation]);

const SwiperImage = ({
  pagination,
  mouseWheel,
  spaceBetween,
  slidesPerView,
  vehicleDetails,
  currentIndex,
  setSwiperInstance,
  handleModalToggle,
}) => {
  const [loadedImages, setLoadedImages] = useState({});
  const { search } = useLocation();
  const { edge = false } = useSelector((state) => state?.uiConfig) || {};
  useEffect(() => {
    return () => {
      setLoadedImages({});
    };
  }, [search]);

  const handleImageLoad = (index) => {
    setLoadedImages((prev) => ({ ...prev, [index]: true }));
  };

  return (
    <Swiper
      key={vehicleDetails?.length + 1}
      onSwiper={setSwiperInstance}
      spaceBetween={spaceBetween}
      navigation={{
        nextEl: ".swiper-button-next-car",
        prevEl: ".swiper-button-prev-car",
      }}
      pagination={pagination ? { clickable: true } : false}
      slidesPerView={slidesPerView}
      mousewheel={mouseWheel}
      initialSlide={currentIndex}
      breakpoints={{
        320: {
          slidesPerView: slidesPerView,
          spaceBetween: 10,
        },
        640: {
          slidesPerView: slidesPerView,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: slidesPerView,
          spaceBetween: 20,
        },
      }}
    >
      {vehicleDetails?.length > 0 ? (
        vehicleDetails?.map((item, i) => {
          return (
            <SwiperSlide key={i}>
              <div className="h-[560px] w-full max-md:h-[280px]">
                {!loadedImages[i] && (
                  <div
                    className={`absolute top-0 left-0 h-full w-full bg-gray-300 animate-pulse ${getEdgeClass(edge)}`}
                  ></div>
                )}
                <img
                  className={`${getEdgeClass(edge, "rounded-t-lg")} ${
                    loadedImages[i] ? "opacity-100" : "opacity-0"
                  } h-auto object-cover max-lg:w-full w-full max-md:h-[280px] aspect-[4/3]`}
                  src={item?.downloadUrl + "&w=720&h=680" || notAvailableImg}
                  alt={`Vehicle ${i + 1}`}
                  onError={(e) => {
                    e.target.src = notAvailableImg;
                  }}
                  onClick={() => handleModalToggle(item)}
                  onLoad={() => handleImageLoad(i)}
                />
              </div>
            </SwiperSlide>
          );
        })
      ) : (
        <img src={defaultImg} alt="" />
      )}
    </Swiper>
  );
};

export default SwiperImage;
